<template>
  <in-viewport>
    <news-list :items="news"/>
  </in-viewport>
</template>

<script>
import NewsList from '@/containers/Home/NewsList'

export default {
  components: {
    NewsList
  },
  props: {
    news: {
      type: Array,
      default: () => []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Home/LeadNewsContainer.vue